import { createInjectable } from "ngxtension/create-injectable";
import { inject } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { createLogger } from "@app/shared/util/logger";
import { ANIMATION_DURATION } from '@app/app.constants';

export const RouteGuardService = createInjectable(() => {
  const { log } = createLogger('route-guard.service');
  const authService = inject(AuthService);
  const router = inject(Router);

  function setRedirectUrl(url: string | undefined) {
    if (url) {
      log('setting redirectUrl:', url);

      authService.addAfterLoginCallback(() => {
        log('go to redirectUrl', url);

        setTimeout(() => router.navigateByUrl(url), ANIMATION_DURATION);
      });
    }
  }

  function canActivateOnboarding(): MaybeAsync<GuardResult> {
    if (!authService.requireOnboarding()) {
      return router.navigate(['dashboard'], {
        replaceUrl: true,
      })
    }

    return true;
  }

  function requireLogin(state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (authService.isLoggedIn()) {
      if (authService.requireOnboarding()) {
        setRedirectUrl(state.url);

        return router.navigate(['/onboarding']);
      }

      return true;
    } else {
      setRedirectUrl(state.url);

      return router.navigate(['/login']);
    }
  }

  function requireUnauthenticated(): MaybeAsync<GuardResult> {
    if (authService.isLoggedIn()) {
      if (authService.requireOnboarding()) {
        return router.navigate(['/onboarding']);
      }

      return router.navigate(['/dashboard']);
    } else {
      return true;
    }
  }

  return {
    canActivateOnboarding,
    requireLogin,
    requireUnauthenticated
  }
});
